import React from 'react';
import { View, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import desktop from '../../assets/images/BenefitsWellBeingNutritional/desktop.jpg';
import mobile from '../../assets/images/BenefitsWellBeingNutritional/mobile.jpg';
import {
  Button,
  Collapse,
  MobileAutoSpace,
  PageWithCard,
  Typography,
} from '~/components/@hello-ui';
import { PageWithCardVariant } from '~/components/@hello-ui/PageWithCard/enums/PageWithCardVariant';
import WellBeingNutritional from '~/components/Icons/WellBeingNutritional';

export const BenefitsWellBeingNutritional = () => {
  const backgroundImage = Platform.OS === 'web' ? desktop : mobile;
  const navigation = useNavigation();
  return (
    <>
      <PageWithCard
        variant={PageWithCardVariant.FeaturedImage}
        featuredImageOptions={{
          backgroundImage,
          titleStartContent: <WellBeingNutritional color="white" />,
          title: 'Programa Nutricional',
          onBack: () => {
            navigation.navigate('BenefitsWellBeing');
          },
        }}>
        <View>
          <Typography variant="body2">
            Receba apoio para realizar mudanças positivas em sua{' '}
            <Typography variant="bodyHighlight2">alimentação </Typography>e{' '}
            <Typography variant="bodyHighlight2">corpo</Typography>. Tenha acompanhamento de
            profissionais especializados para montar seu cardápio e cuidar da sua saúde física.
          </Typography>
        </View>
        <View className="pt-24">
          <Collapse title="Saiba mais">
            <Typography variant="body2">
              No Programa Nutricional você realiza{' '}
              <Typography variant="bodyHighlight2">consultas mensais</Typography> com o
              nutricionista e educador físico e também pode tirar suas dúvidas do dia a dia na área
              de suporte na Central de Atendimento.
            </Typography>
          </Collapse>
        </View>
        <MobileAutoSpace />

        <View className="mt-24 w-full items-center self-center text-center">
          <Typography variant="body2">
            <Typography variant="bodyHighlight2">
              Clique abaixo para utilizar seu benefício:
            </Typography>
          </Typography>
          <View style={{ height: 16 }} />
          <>
            <Button
              variant="primary"
              onPress={() =>
                navigation.navigate('BenefitsVideoAppointmentsSchedule', {
                  title: 'Programa Nutricional',
                  benefit: 'programa_nutricional',
                })
              }>
              Acessar
            </Button>
          </>
        </View>
      </PageWithCard>
    </>
  );
};
